import { render } from "./QueryTypeMaster.vue?vue&type=template&id=f3d22010&scoped=true"
import script from "./QueryTypeMaster.vue?vue&type=script&lang=js"
export * from "./QueryTypeMaster.vue?vue&type=script&lang=js"

import "./QueryTypeMaster.vue?vue&type=style&index=0&id=f3d22010&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d22010"]])

export default __exports__